import { QuestionDto } from "../interfaces/api-interfaces";
import { APiBaseService } from "./api-base.service";

export class QuestionService extends APiBaseService {
  constructor() {
    super();
    this.baseUrl = `${process.env.REACT_APP_API_URL}/questions`;
  }
  find(examId: number, target?: "DOCTOR" | "PATIENT"): Promise<QuestionDto[]> {
    const url = this.baseUrl;
    const params = new URLSearchParams({ examId: examId.toString() });
    if (target) {
      params.append("target", target);
    }
    return this.get<QuestionDto[]>(`${url}?${params.toString()}`);
  }
}
